import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { ComboServices } from '../../../services';

@Component({
    selector: 'page-combo-create-partial-tags',
    templateUrl: 'combo-create-partial-tags.html',
})
export class ComboCreatePartialTagsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public comboServices: ComboServices) {
    }

    onChange(val) {
        this.comboServices.combo_tags = val;
    }

    addTag(tag) {
        if (!(this.comboServices.combo_tags.indexOf(tag) > -1)) {
            if (tag != 'eti') {
                this.comboServices.combo_tags.push(tag);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-title/combo-create-partial-tags/combo-create-partial-tags.ts